import { render, staticRenderFns } from "./behaviorMonitoring.vue?vue&type=template&id=7fdf7bed&scoped=true&"
import script from "./behaviorMonitoring.vue?vue&type=script&lang=js&"
export * from "./behaviorMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdf7bed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fdf7bed')) {
      api.createRecord('7fdf7bed', component.options)
    } else {
      api.reload('7fdf7bed', component.options)
    }
    module.hot.accept("./behaviorMonitoring.vue?vue&type=template&id=7fdf7bed&scoped=true&", function () {
      api.rerender('7fdf7bed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sensitive/behaviorMonitoring.vue"
export default component.exports